ColumnasUsuariosCtrl.$inject = ['$log', '$http'];
export default function ColumnasUsuariosCtrl($log, $http) {
    var vm = this;

    var URL_EDIT_COLUMNAS_VISIBLES = Sigo.var.path + '/usuarios/edit-columnas-visibles';

    vm.urlTemplateColumnasUsuario = '/dev/js/app/mantenimiento/columnas-usuarios/columnas-usuarios.html';

    var filterColumns = function (elemento) {
        return issetAndNotEmpty(elemento.mDataProp) && (!isSet(elemento.bVisible) || elemento.bVisible);
    };

    var columnas = {
        'incidencia': {},
        'tarea': {}
    };
    columnas['incidencia']['todas'] = IncidenciasGridCtrl.getColumnas().filter(filterColumns);
    columnas['incidencia']['visible'] = IncidenciasGridCtrl.columnasVisibles;

    columnas['tarea']['todas'] = TareasGridCtrl.getColumnas().filter(filterColumns);
    columnas['tarea']['visible'] = TareasGridCtrl.columnasVisibles;

    var tipo = $('#tipo').html();
    vm.tipo = tipo;
    var idUsrOrGrp = $('#idUsrOrGrp').html();
    var jsonColumnas = $.parseJSON($('#jsonColumnas').html());
    var jsonGrp = $.parseJSON($('#jsonGrp').html());

    vm.info_vis_def = tipo == 'user' ? 'info_vis_por_defecto_usr' : 'info_vis_por_defecto_grp';

    vm.tabs = [
        {tabla: 'incidencia', id: 'incidenciaTab', class: '', columnas: columnas['incidencia']['todas']},
        {tabla: 'tarea', id: 'tareaTab', class: '', columnas: columnas['tarea']['todas']}
    ];

    vm.tabActual = vm.tabs[0].id;

    vm.cambiaTab = function(tabId){
        vm.tabActual = tabId;
    };

    vm.esColumnaVisibleGroup = function (tabla, columna) {
        var ruta = [tabla, columna, 'mostrar'];
        var valor = existeRuta(jsonGrp, ruta) ? jsonGrp[tabla][columna]['mostrar'] : null;

        if (isArrayAndNotEmpty(valor)) {
            var esVisible = false;
            for (var i = 0; i < valor.length; i++) {
                var value = valor[i];
                esVisible = typeof value == 'string' ? value == "true" : value;
                if (esVisible) break;
            }

            return esVisible;
        }

        return undefined;
    };

    vm.esColumnaVisible = function (tabla, columna) {
        var ruta = [tabla, columna, 'mostrar'];
        var valor = existeRuta(jsonColumnas, ruta) ? jsonColumnas[tabla][columna]['mostrar'] : null;

        if (isSet(valor)) return typeof valor == 'string' ? valor == "true" : valor;

        return undefined;
    };

    vm.esColumnaVisiblePorDefecto = visiblePorDefecto;

    function visiblePorDefecto(tabla, columna) {
        if (isSet(columnas[tabla]['visible'][columna]))
            return columnas[tabla]['visible'][columna].visiblePorDefecto;

        return undefined;
    }

    vm.editarColumnasVisiblesSrv = function (tabla, columna, visibilidad) {
        var modelo = {"tabla": tabla, "columnas": [columna], "opciones": {"mostrar": visibilidad}};

        if (jsonColumnas == null) {
            jsonColumnas = {};
            jsonColumnas[tabla] = {};
            jsonColumnas[tabla][columna] = {"mostrar": visibilidad};
        } else if (existeRuta(jsonColumnas, [tabla, columna, "mostrar"])) {
            jsonColumnas[tabla][columna]["mostrar"] = visibilidad;
        } else if (existeRuta(jsonColumnas, [tabla, columna])) {
            if (isObject(jsonColumnas[tabla][columna]))
                jsonColumnas[tabla][columna]["mostrar"] = visibilidad;
            else
                jsonColumnas[tabla][columna] = {"mostrar": visibilidad};
        } else if (existeRuta(jsonColumnas, [tabla])) {
            if (isObject(jsonColumnas[tabla]))
                jsonColumnas[tabla][columna] = {"mostrar": visibilidad};
            else {
                jsonColumnas[tabla] = {};
                jsonColumnas[tabla][columna] = {"mostrar": visibilidad};
            }
        } else {
            jsonColumnas[tabla] = {};
            jsonColumnas[tabla][columna] = {"mostrar": visibilidad};
        }

        $http.post(URL_EDIT_COLUMNAS_VISIBLES + '/' + tipo + '/' + idUsrOrGrp, modelo);
    };
}